import script from "./LocksView.vue?vue&type=script&setup=true&lang=js"
export * from "./LocksView.vue?vue&type=script&setup=true&lang=js"

import "./LocksView.vue?vue&type=style&index=0&id=e30ea854&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e30ea854"]])

export default __exports__